import { ActionType } from '../../types/action';

const listPermission = {
  resource: 'fund-valuation-day',
  action: ActionType.READ,
};
const createPermission = {
  resource: 'fund-valuation-day',
  action: ActionType.CREATE,
};
const updatePermission = {
  resource: 'fund-valuation-day',
  action: ActionType.UPDATE,
};
const deletePermission = {
  resource: 'fund-valuation-day',
  action: ActionType.UPDATE,
};

export const FundValuationDay = {
  list: listPermission,
  create: createPermission,
  update: updatePermission,
  delete: deletePermission,
};
